import { DrawerContent } from "@chakra-ui/react";
import styled from "styled-components";

export const StyledDrawerContent = styled(DrawerContent)`
    background-color: ${props => props.theme.drawer.background} !important;
    color: ${props => props.theme.drawer.color} !important;
`